import request from '@/utils/request'

// 获取错误类型列表
export function getErrorCodes() {
  return request({
    url: '/api/error-codes',
    method: 'get'
  })
}

// 获取题目的错误类型列表
export function getQuestionErrors(questionCode) {
  return request({
    url: `/api/questions/${questionCode}/errors`,
    method: 'get'
  })
}

// 设置题目的错误类型（覆盖式）
export function setQuestionErrors(questionCode, errorCodes) {
  return request({
    url: `/api/questions/${questionCode}/errors`,
    method: 'post',
    data: { error_codes: errorCodes }
  })
}

